import { MASAR } from "@/constants/testIds";
import { SectionLabel } from "@/components/masar/HowItWorks";
import PrivacyContent from "@/components/masar/PrivacyContent";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function PrivacySection() {
  const { t } = useLanguage();
  return (
    <section
      id="privacy"
      data-testid="masar-section-privacy"
      className="relative py-24 sm:py-32 border-t border-white/10 bg-neutral-900/40 scroll-mt-16"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <SectionLabel index="08" label={t("privacySec.chapter")} />

        <div className="mt-4 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            {t("privacySec.titleA")}
            <br />
            {t("privacySec.titleB")}
          </h2>
          <Link
            to="/privacy"
            data-testid="masar-privacy-standalone"
            className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white font-mono uppercase tracking-widest border-b border-white/15 hover:border-[#FF6A1A] pb-1"
          >
            {t("privacySec.open")}
            <ExternalLink size={14} />
          </Link>
        </div>

        <p className="mt-6 text-sm text-neutral-500 font-mono">{t("privacySec.lastUpdated")}</p>

        <div className="mt-10 rounded-3xl bg-neutral-950 border border-white/10 p-6 sm:p-10">
          <div className="max-w-none [&_h2]:mt-10 [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:tracking-tight [&_h2]:text-white [&_h2:first-child]:mt-0 [&_h3]:mt-6 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-neutral-100 [&_p]:leading-relaxed [&_p]:text-neutral-300 [&_p]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:text-neutral-300 [&_ul]:mt-3 [&_li]:mt-1.5 [&_a]:text-[#FF6A1A] [&_a]:underline [&_a]:underline-offset-4">
            <PrivacyContent />
          </div>
        </div>
      </div>
    </section>
  );
}
